import { node } from 'prop-types';

import TopBar from './TopBar';
import useStyles from './styles';
import PoweredImage from '../../assets/images/powered-img.png';

function DashboardLayout({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TopBar />

      <div className={classes.wrapperCollapsed}>
        <div className={classes.contentContainer}>
          <div
            children={children}
            className={classes.content}
          />
        </div>
      </div>
      <img src={PoweredImage} alt='Powered by DynamiCore' className={classes.poweredImage} />
    </div>
  );
}

DashboardLayout.propTypes = {
  children: node,
};

export default DashboardLayout;
